import savingsGoalSuggestions from "@/data/savingsGoalSuggestions";

const sharedUiKeys = [
  "Podcasts",
  "Money Lab",
  "Calendar",
  "Goal Calendar",
  "Toggle Sidebar",
  "Resize sidebar",
  "Create a new savings plan",
  "Open profile",
  "Open settings",
  "Settings",
  "Cycle theme between light, dark, and auto",
  "Sign in to save your progress",
  "SaveySpend AI savings planner logo",
  "Hidden SaveySpend",
  "No Wifi",
  "This feature needs an internet connection. Games, your calendar and saved plans still work offline.",
  "Got it",
] as const;

const englishIdentity = Object.fromEntries(
  [...sharedUiKeys, ...savingsGoalSuggestions].map((key) => [key, key]),
);

export const EXTRA_UI_TRANSLATIONS: Record<string, Record<string, string>> = {
  en: englishIdentity,
  "en-GB": {
    ...englishIdentity,
    "Create a new savings plan": "Create a new savings plan",
    "Sign in to save your progress": "Sign in to save your progress",
  },
  es: {
    "No Wifi": "Sin wifi",
    "This feature needs an internet connection. Games, your calendar and saved plans still work offline.": "Esta función necesita conexión a internet. Los juegos, tu calendario y los planes guardados siguen funcionando sin conexión.",
    "Got it": "Entendido",
    "Podcasts": "Pódcasts",
    "Money Lab": "Laboratorio de dinero",
    "Calendar": "Calendario",
    "Goal Calendar": "Calendario de metas",
    "Toggle Sidebar": "Alternar barra lateral",
    "Resize sidebar": "Cambiar tamaño de la barra lateral",
    "Create a new savings plan": "Crear un nuevo plan de ahorro",
    "Open profile": "Abrir perfil",
    "Open settings": "Abrir ajustes",
    "Settings": "Ajustes",
    "Cycle theme between light, dark, and auto": "Cambiar tema entre claro, oscuro y automático",
    "Sign in to save your progress": "Inicia sesión para guardar tu progreso",
    "SaveySpend AI savings planner logo": "Logotipo del planificador de ahorro con IA de SaveySpend",
    "Hidden SaveySpend": "SaveySpend oculto",
  },
  fr: {
    "No Wifi": "Pas de Wi-Fi",
    "This feature needs an internet connection. Games, your calendar and saved plans still work offline.": "Cette fonctionnalité nécessite une connexion internet. Les jeux, votre calendrier et vos plans enregistrés fonctionnent toujours hors ligne.",
    "Got it": "Compris",
    "Podcasts": "Podcasts",
    "Money Lab": "Labo argent",
    "Calendar": "Calendrier",
    "Goal Calendar": "Calendrier des objectifs",
    "Toggle Sidebar": "Afficher ou masquer la barre latérale",
    "Resize sidebar": "Redimensionner la barre latérale",
    "Create a new savings plan": "Créer un nouveau plan d'épargne",
    "Open profile": "Ouvrir le profil",
    "Open settings": "Ouvrir les paramètres",
    "Settings": "Paramètres",
    "Cycle theme between light, dark, and auto": "Changer le thème entre clair, sombre et auto",
    "Sign in to save your progress": "Connectez-vous pour enregistrer votre progression",
    "SaveySpend AI savings planner logo": "Logo du planificateur d'épargne IA SaveySpend",
    "Hidden SaveySpend": "SaveySpend caché",
  },
  de: {
    "No Wifi": "Kein WLAN",
    "This feature needs an internet connection. Games, your calendar and saved plans still work offline.": "Diese Funktion benötigt eine Internetverbindung. Spiele, dein Kalender und gespeicherte Pläne funktionieren weiterhin offline.",
    "Got it": "Verstanden",
    "Podcasts": "Podcasts",
    "Money Lab": "Geldlabor",
    "Calendar": "Kalender",
    "Goal Calendar": "Zielkalender",
    "Toggle Sidebar": "Seitenleiste umschalten",
    "Resize sidebar": "Seitenleiste vergrößern oder verkleinern",
    "Create a new savings plan": "Neuen Sparplan erstellen",
    "Open profile": "Profil öffnen",
    "Open settings": "Einstellungen öffnen",
    "Settings": "Einstellungen",
    "Cycle theme between light, dark, and auto": "Design zwischen hell, dunkel und automatisch wechseln",
    "Sign in to save your progress": "Melden Sie sich an, um Ihren Fortschritt zu speichern",
    "SaveySpend AI savings planner logo": "Logo des SaveySpend KI-Sparplaners",
    "Hidden SaveySpend": "Verstecktes SaveySpend",
  },
  zh: {
    "No Wifi": "无 Wi-Fi",
    "This feature needs an internet connection. Games, your calendar and saved plans still work offline.": "此功能需要互联网连接。游戏、日历和已保存的计划仍可离线使用。",
    "Got it": "知道了",
    "Podcasts": "播客",
    "Money Lab": "金钱实验室",
    "Calendar": "日历",
    "Goal Calendar": "目标日历",
    "Toggle Sidebar": "切换侧边栏",
    "Resize sidebar": "调整侧边栏大小",
    "Create a new savings plan": "创建新的储蓄计划",
    "Open profile": "打开个人资料",
    "Open settings": "打开设置",
    "Settings": "设置",
    "Cycle theme between light, dark, and auto": "在浅色、深色和自动主题之间切换",
    "Sign in to save your progress": "登录以保存你的进度",
    "SaveySpend AI savings planner logo": "SaveySpend AI 储蓄规划器标志",
    "Hidden SaveySpend": "隐藏的 SaveySpend",
  },
  ru: {
    "No Wifi": "Нет Wi-Fi",
    "This feature needs an internet connection. Games, your calendar and saved plans still work offline.": "Для этой функции нужен интернет. Игры, календарь и сохранённые планы работают и без сети.",
    "Got it": "Понятно",
    "Podcasts": "Подкасты",
    "Money Lab": "Лаборатория денег",
    "Calendar": "Календарь",
    "Goal Calendar": "Календарь целей",
    "Toggle Sidebar": "Переключить боковую панель",
    "Resize sidebar": "Изменить размер боковой панели",
    "Create a new savings plan": "Создать новый план сбережений",
    "Open profile": "Открыть профиль",
    "Open settings": "Открыть настройки",
    "Settings": "Настройки",
    "Cycle theme between light, dark, and auto": "Переключать тему между светлой, темной и авто",
    "Sign in to save your progress": "Войдите, чтобы сохранить прогресс",
    "SaveySpend AI savings planner logo": "Логотип ИИ-планировщика сбережений SaveySpend",
    "Hidden SaveySpend": "Скрытый SaveySpend",
  },
  ja: {
    "No Wifi": "Wi-Fiがありません",
    "This feature needs an internet connection. Games, your calendar and saved plans still work offline.": "この機能にはインターネット接続が必要です。ゲーム、カレンダー、保存したプランはオフラインでも使えます。",
    "Got it": "了解",
    "Podcasts": "ポッドキャスト",
    "Money Lab": "お金ラボ",
    "Calendar": "カレンダー",
    "Goal Calendar": "目標カレンダー",
    "Toggle Sidebar": "サイドバーを切り替え",
    "Resize sidebar": "サイドバーの幅を変更",
    "Create a new savings plan": "新しい貯金プランを作成",
    "Open profile": "プロフィールを開く",
    "Open settings": "設定を開く",
    "Settings": "設定",
    "Cycle theme between light, dark, and auto": "ライト、ダーク、自動テーマを切り替え",
    "Sign in to save your progress": "進行状況を保存するにはログインしてください",
    "SaveySpend AI savings planner logo": "SaveySpend AI貯金プランナーロゴ",
    "Hidden SaveySpend": "隠れたSaveySpend",
  },
  ko: {
    "No Wifi": "와이파이 없음",
    "This feature needs an internet connection. Games, your calendar and saved plans still work offline.": "이 기능에는 인터넷 연결이 필요합니다. 게임, 캘린더, 저장된 플랜은 오프라인에서도 사용할 수 있습니다.",
    "Got it": "확인",
    "Podcasts": "팟캐스트",
    "Money Lab": "머니 랩",
    "Calendar": "캘린더",
    "Goal Calendar": "목표 캘린더",
    "Toggle Sidebar": "사이드바 전환",
    "Resize sidebar": "사이드바 크기 조정",
    "Create a new savings plan": "새 저축 계획 만들기",
    "Open profile": "프로필 열기",
    "Open settings": "설정 열기",
    "Settings": "설정",
    "Cycle theme between light, dark, and auto": "라이트, 다크, 자동 테마 전환",
    "Sign in to save your progress": "진행 상황을 저장하려면 로그인하세요",
    "SaveySpend AI savings planner logo": "SaveySpend AI 저축 플래너 로고",
    "Hidden SaveySpend": "숨겨진 SaveySpend",
  },
};